var React = require('react');

function Across (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0}),React.createElement("g",{"id":"icomoon-ignore","key":1}),React.createElement("path",{"d":"M537.377 428.721l-428.721-428.721-57.164 57.164 428.721 428.721-428.74 428.741 57.164 57.161 428.74-428.738 428.74 428.738 57.161-57.161-428.738-428.741 428.722-428.72-57.166-57.164-428.718 428.72z","key":2})]);
}

Across.defaultProps = {"version":"1.1","width":"1024","height":"1024","viewBox":"0 0 1024 1024"};

module.exports = Across;

Across.default = Across;
